import { Routes, Route, Navigate } from "react-router-dom";
import React, { useState } from 'react';
import Menu from '../pages/Menu';
import Categories from '../pages/Dashboard/categories'
import Language from '../pages/Dashboard/language'
import Control from '../pages/Dashboard/control'
import { GuildContext } from '../utils/contexts/GuildContext';
import { Guild } from '../utils/types';

function Dashboard() {
  const [guild, setGuild] = useState<Guild>();
  const updateGuild = (guild: Guild) => setGuild(guild);

  // console.log(guild)

  return (
    <GuildContext.Provider value={{ guild, updateGuild }}>
      <Routes>
        <Route path="/menu" element={<Menu />} />
        <Route path="/dashboard/categories" element={guild ? <Categories /> : <Navigate replace to="/menu" />} />
        <Route path="/dashboard/language" element={guild ? <Language /> : <Navigate replace to="/menu" />} />
        <Route path="/dashboard/control" element={guild ? <Control /> : <Navigate replace to="/menu" />} />
      </Routes>
    </GuildContext.Provider>
  )
}

export default Dashboard